var BillingHistoryStrings = {
    title: function () { return 'Billing History'; },
    description: function () { return 'Download billing history reports.'; },
    contactSupport: function () {
        return 'If you need older billing history reports, please contact work-support@doordash.com';
    },
    billingHistoryListHeaderMonth: function () { return 'Month'; },
    billingHistoryListHeaderEM: function () { return 'Expensed Meals Bill'; },
    billingHistoryListHeaderDP: function () { return 'DashPass Bill'; },
    downloadButtonTitle: function () { return 'Download'; },
    downloadPdfTitle: function () { return 'PDF summary'; },
    downloadCsvTitle: function () { return 'CSV transactions'; },
};
export default BillingHistoryStrings;
